<template>
  <div
    class="submit-info">
    赤色の日付は
    <a
      href="https://narasu.jp/client/faqs/157"
      target="_blank"
      class="calendar-link">
      サブミット
    </a>
    ができます
  </div>
</template>

<script>

export default {
  name: 'SubmitDatePickerFooter',

}
</script>

<style scoped>
.submit-info {
  color:black;
  font-size: 12px;
  padding: 5px 15px;
}
.calendar-link {
  color: #0b57d0;
  cursor: pointer;
  text-decoration: none;
}
.calendar-link:hover {
  color: blue;
  text-decoration: underline;
}
</style>
